import { useMemo } from "react";
import { SimpleSelect } from "@/shared/ui/SimpleSelect";
import type { KPIPeriodFilter } from "../../domain/types";

interface KPIPeriodFilterProps {
  value: KPIPeriodFilter;
  onChange: (filter: KPIPeriodFilter) => void;
}

export function KPIPeriodFilter({ value, onChange }: KPIPeriodFilterProps) {
  const currentYear = new Date().getFullYear();
  const years = useMemo(() => {
    const yearsList = [];
    for (let i = currentYear - 2; i <= currentYear + 2; i++) {
      yearsList.push({ value: String(i), label: String(i) });
    }
    return yearsList;
  }, [currentYear]);

  const months = useMemo(() => {
    const monthNames = [
      "ມັງກອນ",
      "ກຸມພາ",
      "ມີນາ",
      "ເມສາ",
      "ພຶດສະພາ",
      "ມິຖຸນາ",
      "ກໍລະກົດ",
      "ສິງຫາ",
      "ກັນຍາ",
      "ຕຸລາ",
      "ພະຈິກ",
      "ທັນວາ",
    ];
    return Array.from({ length: 12 }, (_, i) => ({
      value: String(i + 1),
      label: monthNames[i],
    }));
  }, []);

  const quarters = useMemo(() => {
    return [
      { value: "1", label: "Q1" },
      { value: "2", label: "Q2" },
      { value: "3", label: "Q3" },
      { value: "4", label: "Q4" },
    ];
  }, []);

  return (
    <div
      className="flex items-center gap-2"
      data-tourid="overview-period-filter"
    >
      <SimpleSelect
        value={value.periodType}
        onValueChange={(periodType) => {
          const now = new Date();
          if (periodType === "monthly") {
            onChange({
              periodType: "monthly",
              year: value.year,
              month: now.getMonth() + 1,
            });
          } else {
            onChange({
              periodType: "quarterly",
              year: value.year,
              quarter: Math.floor(now.getMonth() / 3) + 1,
            });
          }
        }}
        options={[
          { value: "monthly", label: "ເດືອນ" },
          { value: "quarterly", label: "ໄຕມາດ" },
        ]}
        className="w-32"
      />

      <SimpleSelect
        value={String(value.year)}
        onValueChange={(yearStr) => {
          onChange({
            ...value,
            year: Number.parseInt(yearStr, 10),
          });
        }}
        options={years}
        className="w-24"
      />

      {value.periodType === "monthly" ? (
        <SimpleSelect
          value={value.month ? String(value.month) : ""}
          onValueChange={(monthStr) => {
            onChange({
              ...value,
              month: Number.parseInt(monthStr, 10),
            });
          }}
          options={months}
          className="w-24"
        />
      ) : (
        <SimpleSelect
          value={value.quarter ? String(value.quarter) : ""}
          onValueChange={(quarterStr) => {
            onChange({
              ...value,
              quarter: Number.parseInt(quarterStr, 10),
            });
          }}
          options={quarters}
          className="w-24"
        />
      )}
    </div>
  );
}
